module.exports = __webpack_public_path__ + "static/media/pasta.cc46c71d.svg";